// mobile-detection.service.ts
import { Injectable, signal, OnDestroy, inject, PLATFORM_ID } from "@angular/core";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { isPlatformBrowser } from "@angular/common";

@Injectable({ providedIn: "root" })
export class MobileDetectionService implements OnDestroy {
  private readonly mobileBreakpoint = 768;
  private resizeSubscription: Subscription | null = null;
  private platformId = inject(PLATFORM_ID);

  // Public signal
  isMobile = signal(false);

  constructor() {
    this.initialize();
  }

  private initialize(): void {
    // Only initialize in browser environment
    if (!isPlatformBrowser(this.platformId)) return;

    // Initial check
    this.checkMobile();

    // Setup resize listener with debounce
    this.resizeSubscription = fromEvent(window, "resize")
      .pipe(debounceTime(150))
      .subscribe(() => {
        this.checkMobile();
      });
  }

  private checkMobile(): void {
    const mobile = window.innerWidth <= this.mobileBreakpoint;
    this.isMobile.set(mobile);
  }

  ngOnDestroy(): void {
    this.resizeSubscription?.unsubscribe();
  }
}
